// extracted by mini-css-extract-plugin
export default {"item":"TableWithButton_item__egKFm","footer":"TableWithButton_footer__yLxjz","button":"TableWithButton_button__rj7HX"};